import {GOOGLE_TAG_MANAGER_CONTAINER_ID} from './googleTagManager'

const GTM_SCRIPT_ID = 'gtm-container'

/**
 * Loads the agency-managed GTM container directly rather than injecting the vendor's inline
 * bootstrap snippet, which exists only to run these steps from a `<script>` body. Callers own the
 * consent decision.
 */
export function initGoogleTagManager(): void {
  if (typeof window === 'undefined') return

  if (document.getElementById(GTM_SCRIPT_ID)) return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({'gtm.start': new Date().getTime(), event: 'gtm.js'})

  const script = document.createElement('script')
  script.id = GTM_SCRIPT_ID
  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GOOGLE_TAG_MANAGER_CONTAINER_ID}`
  document.head.appendChild(script)
}
